import { render, staticRenderFns } from "./EmpresaForm.vue?vue&type=template&id=527e984b"
import script from "./EmpresaForm.vue?vue&type=script&lang=js"
export * from "./EmpresaForm.vue?vue&type=script&lang=js"
import style0 from "./EmpresaForm.vue?vue&type=style&index=0&id=527e984b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports